import { hasApiSession, request } from "./core";
import type { OnboardingJourneyResponse } from "./types";

export async function getOnboardingJourney(): Promise<OnboardingJourneyResponse | null> {
  if (!hasApiSession()) return null;
  return request<OnboardingJourneyResponse>("/api/onboarding/journey", {
    method: "GET",
    auth: true,
  });
}

export async function refreshOnboardingJourney(): Promise<OnboardingJourneyResponse | null> {
  if (!hasApiSession()) return null;
  return request<OnboardingJourneyResponse>("/api/onboarding/journey/refresh", {
    method: "POST",
    auth: true,
  });
}

export async function resumeOnboardingJourney(): Promise<OnboardingJourneyResponse | null> {
  if (!hasApiSession()) return null;
  return request<OnboardingJourneyResponse>("/api/onboarding/journey/resume", {
    method: "POST",
    auth: true,
  });
}

export async function skipOnboardingJourney(): Promise<OnboardingJourneyResponse | null> {
  if (!hasApiSession()) return null;
  return request<OnboardingJourneyResponse>("/api/onboarding/journey/skip", {
    method: "POST",
    auth: true,
  });
}

export async function acknowledgeOnboardingStreak(): Promise<OnboardingJourneyResponse | null> {
  if (!hasApiSession()) return null;
  return request<OnboardingJourneyResponse>(
    "/api/onboarding/journey/streak/acknowledge",
    {
      method: "POST",
      auth: true,
    }
  );
}
